module.exports = __webpack_public_path__ + "img/sign.417bb654.jpg";